import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesInventarios() {
  const { user } = useContext(AuthContext);

  const secciones = [
    { section: "Producto Terminado", items: [
      { label: "Inventario", icon: "fas fa-warehouse", color: "#0d9488", href: "/ListadoInventarios", enabled: !!(user.menu_inventarios && user.inventarios) },
      { label: "Seguimiento", icon: "fas fa-search", color: "#0d9488", href: "/ListadoSeguimiento", enabled: !!(user.menu_inventarios && user.inventarios) },
      { label: "Traspasos", icon: "fas fa-sign-out-alt", color: "#0d9488", href: "/ListadoTraspasosSalida", enabled: !!(user.menu_inventarios && user.menu_traspasos_salida) },
      { label: "Almacenes", icon: "fas fa-warehouse", color: "#0d9488", href: "/Areas", enabled: !!(user.menu_inventarios && user.inventarios) },
      { label: "Ajuste", icon: "fas fa-exchange-alt", color: "#0d9488", href: "/ListadoAjuste", enabled: !!(user.menu_inventarios && user.inventarios) },
    ]},
    { section: "Materia Prima", items: [
      { label: "Inventario Telas", icon: "fas fa-warehouse", color: "#2563eb", href: "/ListadoInventariosTelas", enabled: !!(user.menu_inventarios && user.menu_telas) },
      { label: "Seguimiento Telas", icon: "fas fa-search", color: "#2563eb", href: "/ListadoSeguimientoTelas", enabled: !!(user.menu_inventarios && user.menu_telas) },
      { label: "Inventario Habilitacion", icon: "fas fa-tags", color: "#2563eb", href: "/ListadoInventariosHabilitacion", enabled: !!(user.menu_inventarios && user.menu_telas) },
      { label: "Ajuste Habilitacion", icon: "fas fa-plus", color: "#2563eb", href: "/ListadoSalidaHabilitacion", enabled: !!(user.menu_inventarios && user.menu_telas) },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Inventarios"
      descripcion="Producto terminado y materia prima"
      icono="fas fa-warehouse"
      color="#0d9488"
      secciones={secciones}
    />
  );
}

export default BotonesInventarios;
